module.exports = __webpack_public_path__ + "img/47.2.TN.f0e57f21.png";